import { Pipe, PipeTransform } from '@angular/core';
import { tamilNumberToWords } from '../utils/tamil-number-words.util';

@Pipe({
  name: 'tamilWords',
  standalone: true
})
export class TamilWordsPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    return tamilNumberToWords(value);
  }
}
